let isiOS = !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
let isAndroid = !!(navigator.userAgent.indexOf('Android') > -1 || navigator.userAgent.indexOf('Adr') > -1);

window.__BRIDGE_CALLBACK__ = {};
let callbackNum = 0;

export const callHandler = function(name, data, callback, keepalive) {
	let callbackName = '';
	if (callback && typeof callback === 'function') {
		callbackName = `${name}_${callbackNum++}`;
		window.__BRIDGE_CALLBACK__[callbackName] = function(res) {
			callback(res);
			!keepalive && delete window.__BRIDGE_CALLBACK__[callbackName];
		};
	}

	if (!window.android && !window.webkit) {
		console.log('bridge error', data);
		return;
	}

	if (isAndroid) {
		try {
			if (typeof data === 'object') {
				data = JSON.stringify(data);
			}
			window.android[name](data || '', callbackName);
		} catch (e) {
			console.log('android callHandler err', e);
		}
	} else {
		try {
			window.webkit.messageHandlers.webViewApp.postMessage({
				[name]: {
					callbackName: callbackName,
					data: data || {}
				}
			});
		} catch (e) {
			console.log('ios callHandler err', e);
		}
	}
};



// WEBPACK FOOTER //
// ./src/js/jsBridge.js